import React from "react";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import { Badge, Stack, Text, useViewport } from "@bookingcom/bui-react";
import { COMPANY_NAME } from "@flights/constants";
import { mcn } from "../../../utils/mergeClassnames";
import { SOUTHWEST_PHOTOS } from "../../../constants";
import styles from "./SouthwestAirlinesBanner.module.css";

function SouthwestAirlinesBanner() {
  const i18n = useI18n();
  const { isSmall } = useViewport();
  return (
    <Stack direction={isSmall ? "row-reverse" : "row"} gap={0} alignItems="stretch" className={styles.container}>
      <Stack.Item className={styles.innerFirst}>
        <Badge text={i18n.trans(t("ios_flights_index_badge_new"))} variant="constructive" className={styles.badge} />
        <Text variant="strong_1">{i18n.trans(t("ios_flights_index_southwest_header"))}</Text>
        <Text variant="body_1">
          {i18n.trans(t("ios_flights_index_southwest_subheader", { variables: { b_companyname: COMPANY_NAME } }))}
        </Text>
      </Stack.Item>
      <Stack.Item
        attributes={{
          style: {
            backgroundImage: `url(${isSmall ? SOUTHWEST_PHOTOS.homepageSmall : SOUTHWEST_PHOTOS.homepage})`
          }
        }}
        className={mcn(styles.innerSecond, isSmall ? styles.start : styles.end)}
      />
    </Stack>
  );
}

export default SouthwestAirlinesBanner;
